import React, { useEffect, useState } from 'react'
import { Horizontal, Vertical, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import {
  EnvironmentFilled,
  UserSwitchOutlined,
  LoadingOutlined,
  ExclamationCircleFilled,
  CheckCircleFilled,
  ArrowUpOutlined,
  ArrowDownOutlined,
  CaretLeftOutlined,
} from '@ant-design/icons'

import api from '@utils/api'
import moment from 'moment'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'

export const SelectedDirectiveDetails = ({ selectedDirective }) => {
  const [priceStatus, setPriceStatus] = useState({ appearance: 'secondary', lowPrices: 0, totalPrices: 0 })
  const [pricesLoading, setPricesLoading] = useState(true)
  const { selectDirective, viewingPlanned } = useDirectiveContext()
  useEffect(() => {
    setPricesLoading(true)
    api.getDailyDirectivePrices({}, moment().toISOString(), selectedDirective.curve_group_id).then((resp) => {
      const lowCount = resp.data.filter((price) => price.is_low).length
      const lowPercentage = lowCount / resp.data.length
      setPriceStatus({
        appearance: lowPercentage < 0.5 ? 'error' : 'success',
        totalPrices: resp.data.length,
        lowPrices: lowCount,
      })
      setPricesLoading(false)
    })
  }, [selectedDirective])
  return (
    <Horizontal flex={0.75} border='all' borderRadius={3} background='bg-2' className='mt-2 mb-3'>
      <Vertical verticalCenter horizontalCenter style={{ maxWidth: 30 }}>
        <div
          onClick={() => selectDirective(undefined)}
          className='header-back-button flex-1 h-100 vertical-flex-center'
        >
          <Texto category='h6' appearance='medium'>
            <CaretLeftOutlined />
          </Texto>
        </div>
      </Vertical>
      <Vertical className='pl-4' verticalCenter flex={3}>
        <Texto appearance='medium' weight='bold'>
          SELECTED DIRECTIVE
        </Texto>
        <Texto appearance='secondary' weight='bold' category='h3'>
          {selectedDirective.name}
        </Texto>
      </Vertical>
      <Vertical className='pl-3' verticalCenter flex={3}>
        <Texto weight={selectedDirective.supplier ? 600 : 500}>
          <UserSwitchOutlined className='pr-2' /> {selectedDirective.supplier || 'Multiple Suppliers'}
        </Texto>
        <Texto className='mt-2' weight={selectedDirective.terminal ? 600 : 500}>
          <EnvironmentFilled className='pr-2' /> {selectedDirective.terminal || 'Multiple Terminals'}
        </Texto>
      </Vertical>
      <Vertical verticalCenter className='px-3' flex={2}>
        <Texto appearance='medium' weight='bold'>
          PRICE DIFFERENCE
        </Texto>
        <LowestPriceStatus priceStatus={priceStatus} pricesLoading={pricesLoading} />
      </Vertical>
      <DirectiveStatusColumn
        delta={viewingPlanned ? selectedDirective.delta_to_directive : selectedDirective.delta_without_planned}
      />
    </Horizontal>
  )
}
const LowestPriceStatus = ({ pricesLoading, priceStatus }) => {
  if (pricesLoading) {
    return (
      <Texto className='mt-2' appearance='secondary' category='h6' weight='bold'>
        <LoadingOutlined className='mr-2' /> Loading
      </Texto>
    )
  } else if (priceStatus.totalPrices === 0) {
    return (
      <Texto className='mt-2' appearance='error' category='h6' weight='bold'>
        <ExclamationCircleFilled className='mr-2' />
        No Active Prices
      </Texto>
    )
  }

  return (
    <Texto className='mt-2' appearance={priceStatus.appearance} category='h6' weight='bold'>
      {priceStatus.lowPrices} / {priceStatus.totalPrices} Lowest Prices
    </Texto>
  )
}
const DirectiveStatusColumn = ({ delta }) => {
  const StatusIcon = () => {
    if (delta === 0) {
      return (
        <Texto category='h2' appearance='success'>
          <CheckCircleFilled />
        </Texto>
      )
    } else if (delta > 0) {
      return (
        <Texto category='h2' appearance='error'>
          <ArrowUpOutlined />
        </Texto>
      )
    } else if (delta < 0) {
      return (
        <Texto category='h2' appearance='error'>
          <ArrowDownOutlined />
        </Texto>
      )
    } else return null
  }
  const onTarget = delta === 0
  return (
    <Vertical background={onTarget ? 'theme-success-dim' : 'theme-error-dim'} verticalCenter flex={3}>
      <Horizontal>
        <Vertical className='pl-3' horizontalCenter>
          <StatusIcon />
        </Vertical>
        <Vertical className='pr-4' verticalCenter>
          {onTarget ? (
            <>
              <Texto category='h5' align='right' weight='bold' appearance='success'>
                Directive
              </Texto>
              <Texto category='h4' align='right' weight='bold' appearance='success'>
                On Target
              </Texto>
            </>
          ) : (
            <>
              <Texto category='h3' align='right' weight='bold' appearance='error'>
                {addCommasToNumber(Math.abs(delta), 0)}
              </Texto>
              <Texto category='h6' align='right' weight='bold' appearance='error'>
                {delta > 0 ? 'Over' : 'Under'} Target
              </Texto>
            </>
          )}
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
